/**
 * ============================================================
 *  CAROUSEL PERFORMANCE FIX  v1.0
 *  Runtime patches for Slick product-grid carousels.
 *
 *  Works alongside carousel-perf-fix.css and the existing
 *  slider-optimiser.js (which handles autoplay rAF patching).
 *
 *  This script:
 *  1. Strips AOS attributes from cards inside initialised
 *     carousels so AOS never processes them.
 *  2. Applies will-change:transform on .slick-track only
 *     during active transitions (not permanently — saves VRAM).
 *  3. Defers off-screen slide image decoding via loading="lazy".
 *  4. Disables focusOnSelect on mobile (fewer event handlers).
 *  5. Pauses animated border pseudo-elements during swipe and
 *     on off-screen slides (GPU layer savings).
 * ============================================================
 */

(function () {
  'use strict';

  if (window.__CAROUSEL_PERF_FIX__) return;
  window.__CAROUSEL_PERF_FIX__ = true;

  /* ===========================================================
     1. STRIP AOS FROM CAROUSEL CARDS
     AOS intercepts intersection events during Slick swipes.
     We remove the data-aos attributes entirely once Slick has
     initialised so AOS.js skips these nodes.
     =========================================================== */
  function stripAOS(sliderEl) {
    if (!sliderEl) return;
    var aosNodes = sliderEl.querySelectorAll('[data-aos]');
    for (var i = 0; i < aosNodes.length; i++) {
      aosNodes[i].removeAttribute('data-aos');
      aosNodes[i].removeAttribute('data-aos-delay');
      aosNodes[i].removeAttribute('data-aos-duration');
      aosNodes[i].removeAttribute('data-aos-offset');
      aosNodes[i].classList.remove('aos-init', 'aos-animate');
      // Reset any inline styles AOS may have set
      aosNodes[i].style.opacity = '';
      aosNodes[i].style.transform = '';
      aosNodes[i].style.transition = '';
    }
  }

  /* ===========================================================
     2. WILL-CHANGE MANAGEMENT
     Apply will-change:transform on .slick-track only while a
     slide transition is active. Permanent will-change wastes
     GPU memory (one extra texture per slider).
     =========================================================== */
  function manageWillChange(sliderEl) {
    if (!sliderEl) return;
    var track = sliderEl.querySelector('.slick-track');
    if (!track) return;

    var $slider = window.jQuery ? jQuery(sliderEl) : null;
    if (!$slider) return;

    $slider.on('beforeChange', function () {
      track.style.willChange = 'transform';
    });
    $slider.on('afterChange', function () {
      // Small delay so the browser finishes the last composite frame
      setTimeout(function () {
        track.style.willChange = '';
      }, 60);
    });
  }

  /* ===========================================================
     3. LAZY DECODE OFF-SCREEN SLIDE IMAGES
     Tell the browser not to eagerly decode images in slides
     that aren't currently visible. iOS Safari benefits hugely.
     =========================================================== */
  function lazyOffscreen(sliderEl) {
    if (!sliderEl) return;
    var imgs = sliderEl.querySelectorAll('.slick-slide:not(.slick-active) img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].getAttribute('loading')) {
        imgs[i].setAttribute('loading', 'lazy');
        imgs[i].setAttribute('decoding', 'async');
      }
    }
  }

  /* ===========================================================
     4. PATCH MOBILE SLICK OPTIONS
     centerMode creates 2× extra slide clones (doubles DOM).
     focusOnSelect adds click handlers to every single slide.
     Neither is needed for a simple swipe carousel on mobile.
     =========================================================== */
  function patchMobileOptions() {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;

    // Hook into theme.carousel.init if it exists
    if (window.theme && theme.carousel && theme.carousel.init) {
      var origInit = theme.carousel.init;
      theme.carousel.init = function (args) {
        if (args && args.slickOptions) {
          // Keep centerMode (user preference) but disable focusOnSelect
          // (adds expensive click handlers to every slide)
          if (args.slickOptions.centerMode === true && args.slickOptions.slidesToShow === 1) {
            args.slickOptions.focusOnSelect = false;
          }
        }
        return origInit.call(this, args);
      };
    }
  }

  /* ===========================================================
     5. PAUSE BORDER ANIMATIONS DURING ACTIVE SWIPE
     Slick adds .slick-swiping during drag — CSS handles
     the pause, but we also freeze @property animations
     (Houdini) which may ignore animation-play-state.
     =========================================================== */
  function manageBordersDuringSwipe(sliderEl) {
    if (!sliderEl) return;
    var $slider = window.jQuery ? jQuery(sliderEl) : null;
    if (!$slider) return;

    // Before slide change: pause all border animations
    $slider.on('beforeChange', function () {
      var pseudoHosts = sliderEl.querySelectorAll(
        '.ymq-options-img-label, .grad-border'
      );
      for (var i = 0; i < pseudoHosts.length; i++) {
        pseudoHosts[i].style.setProperty('animation-play-state', 'paused', 'important');
      }
    });

    // After slide change: resume borders on active slides only
    $slider.on('afterChange', function () {
      // Pause everything first
      var all = sliderEl.querySelectorAll(
        '.ymq-options-img-label, .grad-border'
      );
      for (var i = 0; i < all.length; i++) {
        all[i].style.setProperty('animation-play-state', 'paused', 'important');
      }
      // Then resume only active slides
      var active = sliderEl.querySelectorAll(
        '.slick-active .ymq-options-img-label, .slick-active .grad-border'
      );
      for (var j = 0; j < active.length; j++) {
        active[j].style.removeProperty('animation-play-state');
      }
    });
  }

  /* ===========================================================
     6. REDUCE PAINT DURING SWIPE
     During swipe, iOS Safari repaints every composited layer
     that moves. Reduce visual complexity by hiding non-essential
     decorations on all slides while dragging.
     =========================================================== */
  function reducePaintDuringSwipe(sliderEl) {
    if (!sliderEl) return;
    var list = sliderEl.querySelector('.slick-list');
    if (!list) return;

    // Use a CSS class to gate the optimisations
    list.addEventListener('touchstart', function () {
      sliderEl.classList.add('carousel-swiping');
    }, { passive: true });

    list.addEventListener('touchend', function () {
      // Small delay so the slide animation completes first
      setTimeout(function () {
        sliderEl.classList.remove('carousel-swiping');
      }, 350); // slightly longer than transitionSpeed (300ms)
    }, { passive: true });

    list.addEventListener('touchcancel', function () {
      sliderEl.classList.remove('carousel-swiping');
    }, { passive: true });
  }

  /* ===========================================================
     7. POST-INIT HOOK — apply fixes to every Slick instance
     =========================================================== */
  function applyFixes(sliderEl) {
    stripAOS(sliderEl);
    manageWillChange(sliderEl);
    lazyOffscreen(sliderEl);
    manageBordersDuringSwipe(sliderEl);
    reducePaintDuringSwipe(sliderEl);
  }

  function patchExisting() {
    if (typeof jQuery === 'undefined') return;
    jQuery('.slick-initialized').each(function () {
      applyFixes(this);
    });
  }

  function hookFutureInits() {
    if (typeof jQuery === 'undefined') return;
    jQuery(document).on('init.slick.carouselPerf', function (event, slick) {
      if (slick && slick.$slider && slick.$slider[0]) {
        // Small delay so Slick finishes building the DOM
        setTimeout(function () {
          applyFixes(slick.$slider[0]);
        }, 50);
      }
    });
  }

  /* ===========================================================
     BOOT
     =========================================================== */
  function boot() {
    patchMobileOptions();
    patchExisting();
    hookFutureInits();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Extra safety for late-loading carousels (Shopify section rendering)
  window.addEventListener('load', function () {
    setTimeout(boot, 200);
  });

  console.log('%c\u26A1 Carousel Perf Fix loaded \u2014 AOS stripped, will-change managed, mobile optimised', 'color:#68d391;font-size:11px;');

})();
